import { useThemeStore, type ResolvedTheme } from '@/store/themeStore';

/** Tema efetivo na tela ('light' | 'dark'), já resolvido contra o sistema. */
export function useColorScheme(): ResolvedTheme {
  return useThemeStore((state) => state.colorScheme);
}
